import React, { useState, useEffect, useRef } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, TextField, IconButton, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, TableCell, TableRow, TableBody, TableContainer, Paper, Table, TableHead, MenuItem, FormControl, InputLabel, Select, Chip } from "@mui/material";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorIcon from "@mui/icons-material/Error";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
export default function Orders() {
    const printRef = useRef();
    const [orders, setOrders] = useState([]);
    const [selectedOrderData, setSelectedOrderData] = useState([]);
    const [orderDetails, setOrderDetails] = useState([]);
    const [search, setSearch] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [orderStatus, setOrderStatus] = useState("");
    const [updateOrderStatus, setUpdateOrderStatus] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [openImg, setOpenImg] = useState(false);
    const [selectedImg, setSelectedImg] = useState("");
    const [addressDetails, setAddressDetails] = useState(null);
    const [selectedOrderNo, setSelectedOrderNo] = useState("");
    const [selectedCourierName, setSelectedCourierName] = useState("");
    const [statusModal, setStatusModal] = useState(false);
    const [shippingModal, setShippingModal] = useState(false);
    const [shippingStatus, setShippingStatus] = useState("");
    const [finalAmount, setFinalAmount] = useState(0);
    const [viewAddressId, setViewAddressId] = useState(0);
    const [resellerData, setResellerData] = useState([]);
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        date.setMinutes(date.getMinutes());
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        hours = String(hours).padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    };
    useEffect(() => {
        fetchOrdersData();
    }, []);
    const fetchOrdersData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "order/admin/all";
            const response = await makeRequest("get", url);
            if (response) {
                setOrders(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleViewOrderDetails = async (order) => {
        setSelectedOrderData(order);
        setSelectedOrderNo(order?.rfId);
        setFinalAmount(order?.final_amount);
        setSelectedCourierName(order?.courier_name);
        setViewAddressId(order?.checkout_id);
        setLoading(true);
        try {
            let url = webEndPoint + "order/details/" + order?.rfId;
            const response = await makeRequest("get", url);
            if (response) {
                setOrderDetails(response?.data);
                setOpenModal(true);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleClose = () => {
        setOpenModal(false);
    };
    const handleUpdateStatus = async (order) => {
        setSelectedOrderNo(order?.rfId);
        setUpdateOrderStatus("");
        setStatusModal(true);
        setUpdateOrderStatus(order?.order_status);
    };
    const handleUpdatePayment = async (order) => {
        setSelectedOrderNo(order?.rfId);
        setShippingModal(true);
        setLoading(true);
        try {
            let url = webEndPoint + "order-status-history/order/" + order?.rfId;
            const response = await makeRequest("get", url);
            if (response) {
                setShippingStatus(response?.data[0]?.remarks);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleViewAddress = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "checkout/address/" + viewAddressId;
            const response = await makeRequest("get", url);
            if (response?.data) {
                setAddressDetails(response.data);
                setOpenAddressModal(true);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "checkout/" + viewAddressId;
            const response = await makeRequest("get", url);
            if (response?.data) {
                setResellerData(response.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchOrders = async () => {
        setLoading(true);
        const params = {
            status: orderStatus,
            from_date: fromDate,
            to_date: toDate
        };
        try {
            const queryString = new URLSearchParams(params).toString();
            let url = `${webEndPoint}order/admin/all?${queryString}`;
            const response = await makeRequest("get", url);
            if (response) {
                setOrders(response?.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handlePrint = () => {
        const content = printRef.current;
        if (!content) return;
        const printWindow = window.open("", "_blank");
        printWindow.document.open();
        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Print Label</title>
            <style>
                @page {
                    size: A6;
                    margin: 5mm;
                }
                body {
                    margin: 0;
                    padding: 0;
                    font-family: Arial, sans-serif;
                }
                .a6-label {
                    width: 100%;
                    font-size: 14px;
                    line-height: 1.3;
                }
                .section {
                    padding: 6px;
                    margin-bottom: 6px;
                }
                .title {
                    font-weight: bold;
                    font-size: 14px;
                    margin-bottom: 4px;
                }
                .from * {
                    font-size: 14px !important;
                    margin: 1px 0 !important;
                }
                .to * {
                    font-size: 18px !important;
                    margin: 1px 0 !important;
                }
                .section * {
                    margin: 1px 0 !important;
                }
            </style>
        </head>
        <body>
            ${content.innerHTML}
        </body>
        </html>
    `);
        printWindow.document.close();
        printWindow.onload = function () {
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 300);
        };
    };
    const getStatusProps = (status) => {
        switch (status) {
            case "PLACED":
                return {
                    sx: {
                        bgcolor: "#f6fa11",
                        color: "#000000",
                        fontWeight: 600,
                    },
                    icon: <ShoppingCartIcon fontSize="small" />,
                };

            case "CONFIRMED":
                return {
                    sx: {
                        bgcolor: "#E3F2FD",
                        color: "#1565C0",
                        fontWeight: 600,
                    },
                    icon: <CheckCircleIcon fontSize="small" />,
                };

            case "SHIPPED":
                return {
                    sx: {
                        bgcolor: "#0cfc20",
                        color: "#070707",
                        fontWeight: 600,
                    },
                    icon: <LocalShippingIcon fontSize="small" />,
                };

            case "DELIVERED":
                return {
                    sx: {
                        bgcolor: "#D1FAE5",
                        color: "#047857",
                        fontWeight: 600,
                    },
                    icon: <DoneAllIcon fontSize="small" />,
                };

            case "CANCELLED":
                return {
                    sx: {
                        bgcolor: "#FDECEC",
                        color: "#D32F2F",
                        fontWeight: 600,
                    },
                    icon: <CancelIcon fontSize="small" />,
                };

            default:
                return {};
        }
    };
    const getPaymentProps = (status) => {
        switch (status?.toLowerCase()) {
            case "paid":
                return {
                    color: "success",
                    variant: "filled",
                    icon: <CheckCircleIcon fontSize="small" />,
                };
            case "unpaid":
                return {
                    color: "error",
                    variant: "filled",
                    icon: <CancelIcon fontSize="small" />,
                };
            case "pending":
                return {
                    color: "warning",
                    variant: "filled",
                    icon: <HourglassEmptyIcon fontSize="small" />,
                };
            case "failed":
                return {
                    color: "error",
                    variant: "outlined",
                    icon: <ErrorIcon fontSize="small" />,
                };
            default:
                return {
                    color: "default",
                    variant: "outlined",
                };
        }
    };
    const handleUpdateOrderStatus = async () => {
        setLoading(true);
        const orderStatus = {
            order_status: updateOrderStatus
        }
        try {
            let url = webEndPoint + "order/status/" + selectedOrderNo;
            const response = await makeRequest("put", url, orderStatus);
            if (response) {
                setStatusModal(false);
                setMessage("Order Status Updated Successfully");
                setUpdateOrderStatus("");
                setSnackbar(true);
                fetchOrdersData();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleUpdateShippingStatus = async () => {
        setLoading(true);
        const orderStatus = {
            order_id: selectedOrderNo,
            status: shippingStatus,
            remarks: shippingStatus
        }
        try {
            let url = webEndPoint + "order-status-history";
            const response = await makeRequest("post", url, orderStatus);
            if (response) {
                setShippingModal(false);
                setMessage("Shipping Status Updated Successfully");
                setShippingStatus("");
                setSnackbar(true);
                fetchOrdersData();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleExportCSV = () => {
        if (!filteredState || filteredState.length === 0) {
            setMessage("No data to export");
            setSnackbar(true);
            return;
        }
        const headers = [
            "S.No",
            "Order No",
            "Order ID",
            "Order Date",
            "User Name",
            "Mobile",
            "Order Amount",
            "Status",
            "Payment Status"
        ];
        const csvRows = [
            headers.join(","),
            ...filteredState.map((o, index) => [
                index + 1,
                "SA" + o.rfId,
                o.order_number,
                formatDate(o.created_at),
                o.first_name,
                o.mobile_number,
                Number(o.final_amount || 0).toFixed(2),
                o.order_status,
                o.payment_status
            ].join(",")),
            [
                "",
                "",
                "",
                "",
                "",
                "TOTAL",
                totalOrderAmount.toFixed(2),
                "",
                ""
            ].join(",")
        ];
        const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "orders_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const subtotal = orderDetails?.reduce((sum, o) => { return sum + Number(o.total_price || 0); }, 0);
    const totalQty = orderDetails?.reduce((sum, o) => { return sum + Number(o.quantity || 0); }, 0);
    const discount = orderDetails?.discount_amount;
    const totalAmount = subtotal - discount;
    const shippingCharges = finalAmount - subtotal;
    const filteredState = orders?.filter((d) =>
        d?.mobile_number?.toLowerCase().includes(search?.toLowerCase()) || d?.first_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const totalOrderAmount = filteredState?.reduce(
        (sum, order) => sum + Number(order?.final_amount || 0),
        0
    );
    const totalOrders = filteredState?.length || 0;
    const columns = ["S.No", "Order No", "Order ID", "Order Date", "User Name", "Mobile", "Order Amount", "Payment ID", "Order Status", "Payment Status", "Actions"];
    const rows = filteredState?.map((o, i) => [i + 1, "SA" + o.rfId, o.order_number, formatDate(o.created_at), o.first_name, o.mobile_number, o.final_amount, o.payment_transaction_id,
    <Chip label={o.order_status} {...getStatusProps(o.order_status)} size="small" />,
    <Chip label={o.payment_status} {...getPaymentProps(o.payment_status)} size="small" />,
    <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="View Order Details"><IconButton color="primary" onClick={() => handleViewOrderDetails(o)}><VisibilityIcon /></IconButton></Tooltip>
        <Tooltip title="Update Order Status"><IconButton color="info" onClick={() => handleUpdateStatus(o)}><EditIcon /></IconButton></Tooltip>
        <Tooltip title="Update Shipping Status"><IconButton color="success" onClick={() => handleUpdatePayment(o)}><LocalShippingIcon /></IconButton></Tooltip>
    </Box>
    ]);
    const handleCopy = async () => {
        if (!printRef.current) return;
        const text = printRef.current.innerText
            .replace(/\n{2,}/g, "\n")
            .replace(/[ \t]+\n/g, "\n")
            .trim();
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error("Copy failed", err);
        }
    };
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Orders</Typography>
            <Box
                sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "95%", }}>
                <TextField label="Search By Mobile Number / User Name" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "40%", md: 400 } }} />
                <TextField label="From Date" type="date" size="small" InputLabelProps={{ shrink: true }} value={fromDate} onChange={(e) => setFromDate(e.target.value)} sx={{ width: { xs: "100%", sm: "20%" } }} />
                <TextField label="To Date" type="date" size="small" InputLabelProps={{ shrink: true }} value={toDate} onChange={(e) => setToDate(e.target.value)} sx={{ width: { xs: "100%", sm: "20%" } }} />
                <FormControl size="small" sx={{ width: { xs: "80%", sm: "20%" } }}>
                    <InputLabel>Order Status</InputLabel>
                    <Select value={orderStatus} label="Order Status" onChange={(e) => setOrderStatus(e.target.value)}>
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="PLACED">PLACED</MenuItem>
                        <MenuItem value="CONFIRMED">CONFIRMED</MenuItem>
                        <MenuItem value="SHIPPED">SHIPPED</MenuItem>
                        <MenuItem value="DELIVERED">DELIVERED</MenuItem>
                        <MenuItem value="CANCELLED">CANCELLED</MenuItem>
                    </Select>
                </FormControl>
                <Button variant="contained" onClick={fetchOrders}>Search</Button>
                <Button variant="contained" startIcon={<FileDownloadIcon />} onClick={handleExportCSV}>Export</Button>
            </Box>
            {/* <DataTable columns={columns} rows={rows} loading={false} /> */}
            <Box sx={{ width: "100%", mb: 3, overflowX: "auto" }}>
                <TableContainer component={Paper} elevation={2}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 500 }}>Total Orders</TableCell>
                                <TableCell sx={{ fontWeight: 500 }}>Order Amount Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{totalOrders}</TableCell>
                                <TableCell>
                                    <Typography sx={{ fontWeight: 700, fontSize: "18px" }}>₹ {totalOrderAmount.toFixed(2)}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false}
                getRowStyle={(row) => ({ backgroundColor: row[8]?.props?.label === "SHIPPED" ? "#ffebee" : "inherit" })} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="md">
                <DialogTitle>{`Order List : (Order No - SA${selectedOrderNo ?? ""}`})</DialogTitle>
                <DialogContent>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>S.No</TableCell>
                                    <TableCell>Product Name</TableCell>
                                    <TableCell>Product Image</TableCell>
                                    <TableCell>Color Name</TableCell>
                                    <TableCell>Age</TableCell>
                                    <TableCell>Size</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Quantity</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {orderDetails?.map((o, i) => (
                                    <TableRow key={o.rfId}>
                                        <TableCell>{i + 1}</TableCell>
                                        <TableCell>{o.product_name}</TableCell>
                                        <TableCell>
                                            {o.color_image_url ? (
                                                <img src={o.color_image_url} alt={o.color_name}
                                                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "6px", cursor: "pointer" }}
                                                    onClick={() => { setSelectedImg(o.color_image_url); setOpenImg(true); }} />) : ("-")}
                                        </TableCell>
                                        <TableCell>{o.color_name}</TableCell>
                                        <TableCell>{o.age_name}</TableCell>
                                        <TableCell>{o.size_name}</TableCell>
                                        <TableCell>{o.price}</TableCell>
                                        <TableCell>{o.quantity}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <Box sx={{ mt: 2, p: 2, border: "1px solid #eee", borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                                Order Summary
                            </Typography>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Typography>Subtotal</Typography>
                                <Typography>₹ {selectedOrderData?.total_amount}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Typography>Discount</Typography>
                                <Typography>₹ {selectedOrderData?.discount_amount}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Typography>Shipping Charges</Typography>
                                <Typography>₹ {((selectedOrderData?.final_amount || 0) - ((selectedOrderData?.total_amount || 0) - (selectedOrderData?.discount_amount || 0))).toFixed(2)}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                                <Typography><b>Total Quantity</b></Typography>
                                <Typography><b>{totalQty}</b></Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                <Typography><b>Total Amount</b></Typography>
                                <Typography><b>₹ {selectedOrderData?.final_amount}</b></Typography>
                            </Box>
                        </Box>
                    </TableContainer>
                    <DialogActions sx={{ mt: 2 }}>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button variant="contained" onClick={() => handleViewAddress()}>View Address</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Dialog open={openAddressModal} onClose={() => setOpenAddressModal(false)} fullWidth maxWidth="sm">
                <DialogTitle>Delivery Address</DialogTitle>
                <DialogContent>
                    {addressDetails ? (
                        <Box>
                            <Box ref={printRef} className="a6-label">
                                <Box className="section to">
                                    <Typography className="title">Order No : {selectedOrderNo}, Courier : {selectedCourierName}</Typography>
                                    <Typography className="title">TO</Typography>
                                    <Typography>{addressDetails?.user_name}</Typography>
                                    <Typography>{addressDetails?.address_line1}</Typography>
                                    <Typography>{addressDetails?.city}</Typography>
                                    <Typography>{addressDetails?.district_name}, {addressDetails?.state_name} - {addressDetails?.pincode}</Typography>
                                    <Typography>{addressDetails?.user_mobile}</Typography>
                                </Box>
                                {resellerData?.isSeller == 1 &&
                                    <Box className="section from" >
                                        <Typography className="title" sx={{ mt: 3 }}>FROM</Typography>
                                        <Typography>{resellerData?.seller_name}</Typography>
                                        <Typography>{resellerData?.seller_mobile}</Typography>
                                    </Box>
                                }

                                {/* <Box className="section from" >
                                <Typography className="title" sx={{ mt: 3 }}>FROM</Typography>
                                <Typography>Senthan Amuthan Kids Wear</Typography>
                                <Typography>C/o Keerthana</Typography>
                                <Typography>Door No: 3/7</Typography>
                                <Typography>Sri Lakshmi Garden</Typography>
                                <Typography>Saravanampatty - 641110</Typography>
                                <Typography>9360990836</Typography>
                            </Box> */}
                            </Box>
                            <Box>
                                <br />
                                <Typography>Customer WhatsApp No : {addressDetails?.address_line2}</Typography>
                                <br />
                            </Box>
                        </Box>

                    ) : (
                        <CircularProgress />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePrint} variant="contained">Print</Button>
                    <Button variant="contained" color="success" onClick={handleCopy}>Copy Address</Button>
                    <Button onClick={() => setOpenAddressModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openImg} onClose={() => setOpenImg(false)} maxWidth="md">
                <DialogContent style={{ textAlign: "center" }}>
                    <img src={selectedImg} alt="Preview" style={{ width: "100%", maxHeight: "70vh", objectFit: "contain" }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenImg(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={statusModal} onClose={() => setStatusModal(false)} fullWidth maxWidth="sm">
                <DialogContent>
                    <InputLabel>Order Status - (Order No SA{selectedOrderNo})</InputLabel><br />
                    <Select sx={{ mt: 2 }} value={updateOrderStatus} label="Order Status" onChange={(e) => setUpdateOrderStatus(e.target.value)} fullWidth>
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="PLACED">PLACED</MenuItem>
                        <MenuItem value="CONFIRMED">CONFIRMED</MenuItem>
                        <MenuItem value="SHIPPED">SHIPPED</MenuItem>
                        <MenuItem value="DELIVERED">DELIVERED</MenuItem>
                        <MenuItem value="CANCELLED">CANCELLED</MenuItem>
                    </Select>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUpdateOrderStatus} variant="contained">Update Status</Button>
                    <Button onClick={() => setStatusModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={shippingModal} onClose={() => setShippingModal(false)} fullWidth maxWidth="sm">
                <DialogContent>
                    <InputLabel>Shipping Status - (Order No SA{selectedOrderNo})</InputLabel><br />
                    <TextField label="Shipping Details" size="small" value={shippingStatus} onChange={(e) => setShippingStatus(e.target.value)} sx={{ mt: 2 }} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUpdateShippingStatus} variant="contained">Update Status</Button>
                    <Button onClick={() => setShippingModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
}